import { render } from "./indexthreeclinic.vue?vue&type=template&id=043e595a"
import script from "./indexthreeclinic.vue?vue&type=script&lang=js"
export * from "./indexthreeclinic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__